<template>
  <div class="rs-section section-uq">
    <a-affix :offsetTop="0" :target="affixTarget">
      <div class="list-toolbar-wrapper">
        <div class="list-toolbar flex items-center">
          <a-space class="v-mr-auto">
            <a-button icon="unlock" type="primary" size="small" @click="onUnlockAll">解锁</a-button>
            <!-- <a-button icon="check" type="primary" size="small" @click="onPassedAll">审核通过</a-button> -->
            <!-- <a-button icon="stop" type="primary" size="small" @click="onRejectAll">审核不通过</a-button> -->
            <!-- <a-button icon="export" type="link" class="bg-deep-orange text-white" size="small" @click="exportExcel">导出</a-button> -->
            <a-button icon="reload" type="link" class="bg-deep-orange text-white" size="small" @click="load()">刷新</a-button>
            <a-radio-group size="small" v-model="listType" button-style="solid" @change="handleListTypeChange">
              <a-radio-button :value="1"><a-icon type="menu" /></a-radio-button>
              <a-radio-button :value="2"><i class="fa fa-comments-o" /></a-radio-button>
            </a-radio-group>
            <a-input-group compact size="small">
              <a-select size="small" v-model="searchRange">
                <a-select-option value="speakerName">按作者</a-select-option>
                <a-select-option value="content">按内容</a-select-option>
                <a-select-option value="number">按序号</a-select-option>
                <a-select-option value="qType">按分类</a-select-option>
              </a-select>
              <a-input-search size="small" style="width: 140px" v-model="searchKey" @search="handleSearch" allow-clear />
            </a-input-group>
          </a-space>
          <div class="list-toolbar-extra">
            共
            <span class="text-primary font-special">{{ pagination.total }}</span>
            条记录
          </div>
          <div class="list-pagination">
            <a-pagination
              size="small"
              :total="pagination.total"
              :current.sync="pagination.pageNum"
              :page-size="pagination.pageSize"
              show-less-items
              show-size-changer
              show-quick-jumper
              @change="onPageChange"
              @showSizeChange="onPageChange"
            />
          </div>
        </div>
      </div>
    </a-affix>
    <div class="msg-list-table" v-if="listType === 1">
      <a-spin :spinning="loading" tip="加载中...">
        <table class="rs-table table-dense">
          <thead>
            <tr>
              <th width="40" class="text-center"><a-checkbox :checked="checkedAll" @change="onCheckAllChange" /></th>
              <th width="50" class="text-center">序号</th>
              <th width="35%">提问</th>
              <th>回答</th>
              <th width="100" class="text-center">回答状态</th>
              <th width="80" class="text-center">回答操作</th>
            </tr>
          </thead>
          <template v-if="list.length > 0">
            <template v-for="item in list">
              <tbody class="msg-tbody" :key="item.spId" :class="{ 'msg-row-checked': item.checked }">
                <tr class="msg-row-question">
                  <td class="text-center" :rowspan="item.showReplyList.length || 1"><a-checkbox :checked="item.checked" @change="onCheckChange(item)" v-if="item.lockState === 1" /></td>
                  <td class="text-center" :rowspan="item.showReplyList.length || 1">{{ item.spNumber }}</td>
                  <td :rowspan="item.showReplyList.length" class="valign-top">
                    <div class="msg-cell-qa msg-cell-q">
                      <div class="msg-cell-qa__props">
                        <span class="text-bold">{{ item.spSpeakerName }}</span>
                        <span class="v-mx-sm text-bold text-ask">问</span>
                        <span class="msg-info-answerer v-mr-sm" v-if="item.spType === 0">{{ item.spGuest }}</span>
                        <span class="text-grey v-mr-sm">{{ item.spDatetime }}</span>
                        <div class="msg-info-actions">
                          <a-space>
                            <div class="msg-info-action text-indigo" title="解锁" @click="onUnlockSpeak(item)" v-if="item.lockState === 1"><a-icon type="unlock" /></div>
                            <div class="msg-info-action text-indigo" title="审核通过" @click="onPassedSpeak(item)" v-if="item.spState !== 1"><a-icon type="check" /></div>
                            <div class="msg-info-action text-red" title="审核不通过" @click="onRejectSpeak(item)" v-if="item.spState !== 2"><a-icon type="stop" /></div>
                            <div class="msg-info-action text-indigo" title="编辑" @click="onEditSpeak(item, reply)"><a-icon type="edit" /></div>
                          </a-space>
                        </div>
                      </div>
                      <div class="msg-cell-qa__content content-ask" v-html="$utils.convertToHtml(item.spContent)"></div>
                    </div>
                  </td>

                  <template v-if="item.showReplyList.length === 0">
                    <td></td>
                    <td></td>
                    <!-- <td></td> -->
                    <td></td>
                  </template>
                  <template v-else>
                    <!-- <td class="text-center"><a-checkbox :checked="item.showReplyList[0].checked" @change="onCheckChange(item.showReplyList[0])" v-if="item.showReplyList[0].astate === 0" /></td> -->
                    <td style="“vertical-align: top" valign="top">
                      <div class="msg-cell-qa msg-cell-a">
                        <div class="msg-cell-qa__props">
                          <span class="text-bold">{{ item.showReplyList[0].gname }}</span>
                          <span class="v-mx-sm text-bold text-reply">答</span>
                          <span class="text-grey">{{ item.showReplyList[0].datetime }}</span>
                          <div class="msg-info-actions v-ml-md">
                            <a-space>
                              <div class="msg-info-action text-indigo" title="审核通过" @click="onPassedReply(item.showReplyList[0])" v-if="item.showReplyList[0].astate !== 1">
                                <a-icon type="check" />
                              </div>
                              <div class="msg-info-action text-red" title="审核不通过" @click="onRejectReply(item.showReplyList[0])" v-if="item.showReplyList[0].astate !== 2">
                                <a-icon type="stop" />
                              </div>
                              <div class="msg-info-action text-indigo" title="编辑" @click="onEditReply(item, item.showReplyList[0])"><a-icon type="form" /></div>
                            </a-space>
                          </div>
                        </div>
                        <div class="msg-cell-qa__content content-reply" v-html="$utils.convertToHtml(item.showReplyList[0].acontent)"></div>
                      </div>
                    </td>
                    <td class="text-center">
                      <span class="text-red" v-if="item.showReplyList[0].astate === 0">待审核</span>
                      <span v-else-if="item.showReplyList[0].astate === 1">已通过</span>
                      <span class="text-grey" v-else-if="item.showReplyList[0].astate === 2">已封禁</span>
                    </td>
                    <td class="text-center">
                      <a-space class="table-actions" :size="6">
                        <span class="table-action" title="审核通过" @click="onPassedReply(item.showReplyList[0])" v-if="item.showReplyList[0].astate !== 1"><a-icon type="check" /></span>
                        <span class="table-action text-red" title="审核不通过" @click="onRejectReply(item.showReplyList[0])" v-if="item.showReplyList[0].astate !== 2"><a-icon type="stop" /></span>
                        <span class="table-action" title="编辑" @click="onEditReply(item, item.showReplyList[0])"><a-icon type="edit" /></span>
                      </a-space>
                    </td>
                  </template>
                </tr>
                <template v-if="item.showReplyList.length > 1">
                  <tr v-for="reply in item.showReplyList.slice(1)" :key="reply.reId">
                    <!-- <td class="text-center"><a-checkbox :checked="reply.checked" @change="onCheckChange(reply)" v-if="reply.astate === 0" /></td> -->
                    <td style="“vertical-align: top" valign="top">
                      <div class="msg-cell-qa msg-cell-a">
                        <div class="msg-cell-qa__props">
                          <span class="text-bold">{{ reply.gname }}</span>
                          <span class="v-mx-sm text-bold text-reply">答</span>
                          <span class="text-grey">{{ reply.datetime }}</span>
                          <div class="msg-info-actions v-ml-md">
                            <a-space>
                              <div class="msg-info-action text-indigo" title="审核通过" @click="onPassedReply(reply)" v-if="reply.astate !== 1"><a-icon type="check" /></div>
                              <div class="msg-info-action text-red" title="审核不通过" @click="onRejectReply(reply)" v-if="reply.astate === 0"><a-icon type="stop" /></div>
                              <div class="msg-info-action text-indigo" title="编辑" @click="onEditReply(item, reply)"><a-icon type="form" /></div>
                            </a-space>
                          </div>
                        </div>
                        <div class="msg-cell-qa__content content-reply" v-html="$utils.convertToHtml(reply.acontent)"></div>
                      </div>
                    </td>
                    <td class="text-center">
                      <span class="text-red" v-if="reply.astate === 0">待审核</span>
                      <span v-else-if="reply.astate === 1">已通过</span>
                      <span class="text-grey" v-else-if="reply.astate === 2">已封禁</span>
                    </td>
                    <td class="text-center">
                      <a-space class="table-actions" :size="6">
                        <span class="table-action" title="审核通过" @click="onPassedReply(reply)" v-if="reply.astate !== 1"><a-icon type="check" /></span>
                        <span class="table-action text-red" title="审核不通过" @click="onRejectReply(reply)" v-if="reply.astate !== 2"><a-icon type="stop" /></span>
                        <span class="table-action" title="编辑" @click="onEditReply(item, reply)"><a-icon type="edit" /></span>
                      </a-space>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </template>
        </table>
        <div style="padding: 30px 0" v-if="!loading && list.length === 0"><a-empty /></div>
      </a-spin>
    </div>
    <div class="msg-list" v-else-if="listType === 2">
      <a-spin :spinning="loading" tip="加载中...">
        <div class="msg-toolbar flex items-center justify-between">
          <div class="msg-checkbox"><a-checkbox :checked="checkedAll" @change="onCheckAllChange"> 全选 </a-checkbox></div>
        </div>
        <template v-if="list.length > 0">
          <div class="msg-info" v-for="item in list" :key="item.spId" :class="{ 'msg-info-checked': item.checked }">
            <!-- <div class="msg-info-checkbox"><a-checkbox :checked="item.checked" @change="onCheckChange(item)" /></div> -->
            <div class="msg-info-question">
              <div class="msg-info-checkbox"><a-checkbox :checked="item.checked" @change="onCheckChange(item)" /></div>
              <div class="msg-info-container">
                <div class="msg-info-header">
                  <a-tag class="msg-info-number font-special tag-tiny" color="blue">{{ item.spNumber }}</a-tag>
                  <span class="msg-info-questioner">{{ item.spSpeakerName }}</span>
                  <span class="msg-info-op text-ask">问</span>
                  <span class="msg-info-answerer v-mr-sm" v-if="item.spType === 0">{{ item.spGuest }}</span>
                  <span class="msg-info-date v-mr-sm">{{ item.spDatetime }}</span>
                  <div class="msg-info-actions">
                    <a-space>
                      <div class="msg-info-action text-indigo" title="解锁" @click="onUnlockSpeak(item)" v-if="item.lockState === 1"><a-icon type="unlock" />解锁</div>
                      <div class="msg-info-action text-indigo" @click="onPassed(item)" v-if="item.spState !== 1"><a-icon type="check" />审核通过</div>
                      <div class="msg-info-action text-red" @click="onRejectSpeak(item)" v-if="item.spState !== 2"><a-icon type="stop" />审核不通过</div>
                      <div class="msg-info-action text-indigo" @click="onEditSpeak(item)"><a-icon type="edit" />编辑</div>
                    </a-space>
                  </div>
                </div>
                <div class="msg-info-content content-ask" v-html="$utils.convertToHtml(item.spContent)">{{ item.spContent }}</div>
              </div>
            </div>
            <div class="msg-info-replies" v-for="reply in item.showReplyList" :key="reply.reId">
              <div class="msg-info-checkbox"><a-checkbox :checked="reply.checked" @change="onCheckChange(reply)" v-if="reply.astate === 0" /></div>
              <div class="msg-info-container">
                <div class="msg-info-header">
                  <span class="msg-info-answerer">{{ reply.gname }}</span>
                  <span class="msg-info-op text-reply">答</span>
                  <span class="msg-info-date v-mr-md">{{ reply.datetime }}</span>
                  <a-tag class="v-mr-md tag-tiny" color="#f50" v-if="reply.astate === 0">待审核</a-tag>
                  <a-tag class="v-mr-md tag-tiny" color="#333" v-else-if="reply.astate === 2">已封禁</a-tag>
                  <div class="msg-info-actions">
                    <a-space>
                      <div class="msg-info-action text-indigo" @click="onPassedReply(reply)" v-if="reply.astate !== 1"><a-icon type="check" />审核通过</div>
                      <div class="msg-info-action text-red" @click="onRejectReply(reply)" v-if="reply.astate !== 2"><a-icon type="stop" />审核不通过</div>
                      <div class="msg-info-action text-indigo" @click="onEditReply(item, reply)"><a-icon type="form" />编辑</div>
                    </a-space>
                  </div>
                </div>
                <div class="msg-info-content content-reply" v-html="$utils.convertToHtml(reply.acontent)"></div>
              </div>
            </div>
          </div>
        </template>
        <div style="padding: 30px 0" v-if="!loading && list.length === 0"><a-empty /></div>
      </a-spin>
    </div>
    <a-modal destroy-on-close :visible="qModel" :width="800" title="编辑提问" @cancel="handleCloseQForm">
      <question-form :data="selectedQuestion" ref="qForm" />
      <template slot="footer">
        <a-button @click="handleCloseQForm">取 消</a-button>
        <a-button type="primary" :loading="qSaving" @click="handleSaveQForm(0)">保 存</a-button>
        <a-button type="primary" :loading="qSaving" @click="handleSaveQForm(1)" v-if="selectedQuestion && selectedQuestion.spState !== 1">保存并审核通过</a-button>
      </template>
    </a-modal>
    <a-modal destroy-on-close :visible="rModel" :width="800" title="编辑回答" @cancel="handleCloseRForm">
      <reply-form :data="selectedReply" :question="selectedQuestion" ref="rForm" />
      <template slot="footer">
        <a-button @click="handleCloseRForm">取 消</a-button>
        <a-button type="primary" :loading="rSaving" @click="handleSaveRForm(0)">保 存</a-button>
        <a-button type="primary" :loading="rSaving" @click="handleSaveRForm(1)" v-if="selectedReply && selectedReply.astate !== 1">保存并审核通过</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import audit from '@/mixins/audit'
import { getSpeakListByPage, auditReply, auditSpeak, exportSpeak, lockSpeak } from '@/api/interact'
import QuestionForm from './question-form.vue'
import ReplyForm from './reply-form.vue'
import moment from 'moment'
export default {
  components: {
    QuestionForm,
    ReplyForm,
  },
  mixins: [audit],
  data() {
    return {
      rsId: this.$route.query.id,
      listType: 1,
      searchRange: 'speakerName',
      searchKey: '',
      loading: false,
      list: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      selectedQuestion: {},
      qModel: false,
      qSaving: false,
      selectedReply: {},
      rModel: false,
      rSaving: false,
    }
  },
  computed: {
    checkedAll() {
      return this.list.length > 0 && this.list.filter((item) => item.checked).length === this.list.length
    },
  },
  methods: {
    load(pageNum = 1, pageSize = 10) {
      this.loading = true
      // 被禁问题stat=2
      let params = {
        pageNum,
        pageSize,
        rsId: this.rsId,
        state: 1,
        type: 0,
        lockState: 1,
      }
      params[this.searchRange] = this.searchKey.trim()
      getSpeakListByPage(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          records.forEach((item) => {
            item.checked = false
            item.replyList.forEach((reply) => {
              reply.checked = false
              reply.time = moment(reply.datetime, 'YYYY-MM-DD HH:mm:ss').valueOf()
            })
            item.replyList.sort((a, b) => a.time - b.time)
            item.showReplyList = item.replyList.filter((r) => r.astate === 1)
          })
          this.list = records
          this.pagination = {
            pageNum: current,
            pageSize: size,
            total,
          }
        }
        this.loading = false
      })
    },
    onEditSpeak(record) {
      this.selectedQuestion = this.$utils.cloneDeep(record)
      this.qModel = true
    },
    handleSearch() {
      this.load()
    },
    handleListTypeChange() {
      this.load()
    },
    onPageChange(pageNum, pageSize) {
      this.load(pageNum, pageSize)
    },
    handleCloseQForm() {
      this.qModel = false
    },
    handleSaveQForm(passed) {
      this.qSaving = true
      this.$refs.qForm
        .handleSubmit(passed)
        .then(() => {
          this.qSaving = false
          this.qModel = false
          this.load()
          this.$message.success('操作成功')
        })
        .catch((e) => {
          console.log(e)
          this.qSaving = false
        })
    },
    handleCloseRForm() {
      this.rModel = false
    },
    handleSaveRForm(passed) {
      this.rSaving = true
      this.$refs.rForm
        .handleSubmit(passed)
        .then(() => {
          this.rSaving = false
          this.rModel = false
          this.load()
          this.$message.success('操作成功')
        })
        .catch((e) => {
          console.log(e)
          this.rSaving = false
        })
    },
    onCheckChange(item) {
      console.log('onCheckChange', item)
      item.checked = !item.checked
    },
    onCheckAllChange(e) {
      let checked = e.target.checked
      this.list.forEach((item) => {
        item.checked = checked
        // item.replyList.forEach((r) => {
        //   r.checked = checked
        // })
      })
    },
    onEditReply(question, reply) {
      this.selectedQuestion = this.$utils.cloneDeep(question)
      this.selectedReply = this.$utils.cloneDeep(reply)
      this.rModel = true
    },
    handleAuditReply(ids, state) {
      auditReply(ids, state).then(({ data }) => {
        if (data.success) {
          this.$message.success('操作成功')
          this.load()
        } else {
          this.$message.warning('操作失败')
        }
      })
    },
    handleAuditSpeak(ids, state) {
      auditSpeak(ids, state).then(({ data }) => {
        if (data.success) {
          this.$message.success('操作成功')
          this.load()
        } else {
          this.$message.warning('操作失败')
        }
      })
    },
    handleLockSpeak(ids, state) {
      lockSpeak(ids, state).then(({ data }) => {
        if (data.success) {
          this.$message.success('操作成功')
          this.load()
        } else {
          this.$message.warning('操作失败')
        }
      })
    },
    onUnlockAll() {
      // let replyList = this.list
      //   .map((item) => item.replyList)
      //   .flat()
      //   .filter((item) => item.astate === 0)
      // let ids = replyList.reduce((a, b) => (b.checked ? a.concat(b.reId) : a), [])
      // if (ids.length === 0) {
      //   this.$message.warning('请至少选择一条记录！')
      //   return false
      // }
      // this.handleAuditReply(ids.join(','), 1)
      let ids = this.list.reduce((a, b) => (b.checked ? a.concat(b.spId) : a), [])
      this.$message.destroy()
      if (ids.length === 0) {
        this.$message.warning('请至少选择一条记录！')
        return false
      }
      this.handleLockSpeak(ids.join(','), 0)
    },
    onRejectAll() {
      let replyList = this.list
        .map((item) => item.replyList)
        .flat()
        .filter((item) => item.astate === 0)
      let ids = replyList.reduce((a, b) => (b.checked ? a.concat(b.reId) : a), [])
      if (ids.length === 0) {
        this.$message.warning('请至少选择一条记录！')
        return false
      }
      this.handleAuditReply(ids.join(','), 2)
    },
    onUnlockSpeak(item) {
      this.handleLockSpeak(item.spId, 0)
    },
    onPassedReply(item) {
      this.handleAuditReply(item.reId, 1)
    },
    onRejectReply(item) {
      this.handleAuditReply(item.reId, 2)
    },
    onPassedSpeak(item) {
      this.handleAuditSpeak(item.spId, 1)
    },
    onRejectSpeak(item) {
      this.handleAuditSpeak(item.spId, 2)
    },
    exportExcel() {
      // location.href = 'http://127.0.0.1/api/manager/export'
      const fileName = `${this.$parent.data.rsName}_回答待审问题列表`
      // 待审核的回复
      let params = {
        pageSize: -1,
        rsId: this.rsId,
        type: 0,
        state: 1,
        replyState: 0,
      }
      const exporting = this.$message.loading(`正在导出${fileName}...`, 0)
      exportSpeak(params)
        .then(({ data }) => {
          setTimeout(exporting, 400)
          const blob = new Blob([data])
          if ('download' in document.createElement('a')) {
            const dlink = document.createElement('a')
            dlink.download = `${fileName}.xlsx`
            dlink.style.display = 'none'
            dlink.href = URL.createObjectURL(blob)
            document.body.appendChild(dlink)
            dlink.click()
            URL.revokeObjectURL(dlink.href)
            document.body.removeChild(dlink)
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }
        })
        .catch(() => {
          setTimeout(exporting, 200)
          this.$message.warning('操作失败')
        })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
